import { useCallback, useMemo } from 'react'
import { useQuery } from 'apollo-client'
import { track } from 'analytics'

import bannersStrapiQuery from './graph/banners.strapi.graphql'


type UseBrandsBannerProps = {
  placement: 'perfumes' | 'colognes' | 'discover' | 'search'
  skip?: boolean
  onClick?: () => void
}

const useDynamicNavigationBanner = ({ placement, onClick, skip }: UseBrandsBannerProps) => {
  const { data, isFetching } = useQuery(bannersStrapiQuery, {
    client: 'strapi',
    fetchPolicy: 'cache-first',
    skip,
    ssr: false,
  })

  const bannerData = useMemo(() => {
    const bannerData = data?.navigationBanner?.data?.attributes?.[placement]?.banner?.data?.attributes?.banner?.[0]

    if (!bannerData || bannerData.__typename === 'Error') {
      return null
    }

    return {
      to: bannerData?.actionLink,
      bgImage: bannerData?.image?.desktop?.data.attributes.url,
      trackParams: bannerData?.mixpanel?.trackParams,
    }
  }, [ data?.navigationBanner?.data, placement ])

  const handleClick = useCallback(() => {
    track('Banner click', {
      placement: 'Desktop navigation menu',
      content: 'Featured brand',
      link: bannerData.to,
      action: 'link',
      ...bannerData.trackParams,
    })

    if (typeof onClick === 'function') {
      onClick()
    }
  }, [ bannerData, onClick ])

  return {
    isFetching,
    bannerData,
    handleClick,
  }
}

export default useDynamicNavigationBanner
